/* eslint-disable @typescript-eslint/no-use-before-define */
import { configureStore } from "@payping/redux";
import { initI18next, localeNameSpaces } from "@payping/utils/localeUtils";
// import { Modal } from "@payping/web-components";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Persistor } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
// Fix app crash in old safari browsers (sentry issue: DASHWRAPPER-GT)
// eslint-disable-next-line import/no-extraneous-dependencies
import ResizeObserver from "resize-observer-polyfill";

import { AppErrorBoundary } from "./AppErrorBoundary";
import { localeResources } from "./assets/locales/resources";
import { AppStoreStates, reduxConfig } from "./redux/configs";
import reportWebVitals from "./reportWebVitals";
import { sendToAnalytics } from "./web-vitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setToken } from "./utils";
import App from "./App";

import "./apiConfigs";
import "./index.scss";

window.ResizeObserver = ResizeObserver;

const initToken = () => {
  const envToken = process.env.REACT_APP_TOKEN;
  const { auth, organization } = store.getState();
  const reduxToken = organization.token || auth.token;
  if (envToken) {
    setToken.forAll(store.dispatch, envToken);
  } else if (reduxToken) {
    setToken.forApi(reduxToken);
  }
};

const renderAppOnRehydrate = async (): Promise<void> => {
  initToken();
  await initI18next(localeNameSpaces.Wrapper, localeResources);
  const ProfiledApp = Sentry.withProfiler(() => (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor as Persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  ));
  const root = createRoot(document.getElementById("root") as HTMLDivElement);
  root.render(
    <AppErrorBoundary>
      <ProfiledApp />
    </AppErrorBoundary>
  );
  // ReactDOM.render(
  //   <AppErrorBoundary>
  //     <ProfiledApp />
  //   </AppErrorBoundary>,
  //   document.getElementById("root")
  // );
};
export const { store, persistor } = configureStore<AppStoreStates>({
  ...reduxConfig,
  onRehydrated: renderAppOnRehydrate,
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register();
// serviceWorkerRegistration.register({
//   onUpdate: ({ update }) => {
//     Modal.confirm({
//       cancelText: "الان نه",
//       // eslint-disable-next-line no-useless-concat
//       content: "نسخه جدیدتری در دسترس است" + "\n" + "مایلید بروزرسانی انجام شود؟",
//       okText: "بله",
//       onOk: () => {
//         update();
//         setTimeout(() => {
//           window.location.reload();
//         }, 500);
//       },
//       title: "بروزرسانی",
//     });
//   },
// });
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console

reportWebVitals(sendToAnalytics);
